module.exports = __webpack_public_path__ + "static/media/12-1.0a20f64f.mp3";